import * as S from './styles';
import { Control, Controller, FieldErrors, UseFormRegister } from "react-hook-form";
import { IMaskInput } from "react-imask";
//interface
import { IAgreement } from 'Interfaces/IAgreement';
import { Inputs } from 'Interfaces/ICustomerAddress';

interface IProps {
  register: UseFormRegister<Inputs>;
  control: Control<Inputs>;
  errors: FieldErrors<Inputs>;
  agreements: IAgreement[];
}

export default function FormsCustomer({
  control,
  errors,
  register,
  agreements
}: IProps) {

  return (
    <S.Container>
      <S.SeparateDiv>
        <S.FormInput>
          <S.Label>
            Nome do Usuário
            <span>*</span>
          </S.Label>
          <S.Input
            placeholder="Informe o nome"
            type="text"
            {...register("full_name", { required: true })}
          />
          {errors.full_name && (
            <S.InforErro>Campo Obrigatório</S.InforErro>
          )}
        </S.FormInput>

        <S.FormInput>
          <S.Label>
            Bandeira
          </S.Label>
          <S.Select {...register("flag")}>
            <option value="" disabled selected hidden>
              Selecione
            </option>
            <option value="">
              NENHUM
            </option>
            <option value="green">
              Verde
            </option>
            <option value="orange">
              Laranja
            </option>
            <option value="red">
              Vermelha
            </option>
          </S.Select>
        </S.FormInput>
      </S.SeparateDiv>

      <S.SeparateDiv>
        <S.FormInput>
          <S.Label>CPF</S.Label>
          <Controller
            name="cpf"
            control={control}
            render={({ field }) => (
              <IMaskInput
                className='imask'
                id="cpf"
                mask="000.000.000-00"
                placeholder="000.000.000-00"
                onAccept={(value: string) => field.onChange(value)}
                {...field}
              />
            )}
          />
        </S.FormInput>

        <S.FormInput>
          <S.Label>
            Convênio
          </S.Label>
          <S.Select {...register("agreement_id")}>
            <option value="" disabled selected hidden>
              Selecione
            </option>
            {agreements.map((val) => {
              return <option value={val.id}>{val.agreement}</option>;
            })}
          </S.Select>
        </S.FormInput>
      </S.SeparateDiv>

      <S.SeparateDiv>
        <S.FormInput className='inputLeft'>
          <S.Label>Data de Nascimento</S.Label>
          <S.Input
            type="date"
            placeholder="00/00/0000"
            {...register('birth_date')} />
        </S.FormInput>

        <S.FormInput className='inputLeft'>
          <S.Label>Celular Principal</S.Label>
          <Controller
            name="phone_primary"
            control={control}
            render={({ field }) => (
              <IMaskInput
                id="phone_primary"
                mask="(00)00000-0000"
                placeholder="(00)00000-0000"
                onAccept={(value: string) => {
                  field.onChange(value);
                }}
                {...field}
                inputRef={field.ref}
              />

            )}
          />
        </S.FormInput>
      </S.SeparateDiv>

      <S.FormInput>
        <S.Label>E-mail</S.Label>
        <S.Input
          placeholder="exemplo@gmail.com"
          type="email"
          {...register("email")}
        />
      </S.FormInput>
    </S.Container>
  )
}